import { Space } from 'antd';
import type { ReactNode } from 'react';
import { Highlighter } from '@/components/highlighter/Highlighter';
import { Tag } from '@/components/tag/Tag';
import { TagType } from '@/components/tag/enums/TagType';

export const renderOptionLabelWithIdTag = (id: string | null | undefined, name: string, search?: string): ReactNode => (
  <Space size={0}>
    {id && <Tag type={TagType.Normal}>{id}</Tag>}
    <Highlighter highlightedText={search} originalText={name} />
  </Space>
);
